import Proptypes from 'prop-types'
import { StyledToast, StyledContent, StyledIcon, StyledClose } from './styles'

import { MdClear } from 'react-icons/md'

export const Toast = ({ color, icon, text, title, onClose }) => (
  <StyledToast color={color}>
    <StyledContent>
      {icon && <StyledIcon>{icon}</StyledIcon>}

      <div>
        {title && <h2>{title}</h2>}
        <p>{text}</p>
      </div>
    </StyledContent>

    <StyledClose onClick={onClose}>
      <MdClear />
    </StyledClose>
  </StyledToast>
)

Toast.propTypes = {
  color: Proptypes.string,
  icon: Proptypes.node,
  text: Proptypes.string,
  title: Proptypes.string,
  onClose: Proptypes.func,
}

export default Toast
